import { VehicleDataEnum } from '../../../../core/consts/vehicle-data.enum';
import { InsuranceDataEnum } from '../../../../core/consts/insurance-data.enum';
import { VehicleQuestionCode } from '../../../../core/consts/vehicle-question-code.enum';
import { FormConfig } from '../../../models/form-config';
import { FieldType } from '../../../models/field-type';
import { VehicleDataStateService } from '../../../../core/services/impl/section-services/vehicle-data/vehicle-data-state.service';
import { SelectContentText } from '../../../components/fields/multiselect/material-multiselect.component';
import { BeanConfig } from '../../../models/bean-config';
import {today} from '../../../utils/time-utils';
import { VehicleQuestionAnswer } from '../../../../core/consts/vehicle-question-answer.enum';
import { InsuranceDataStateService } from '../../../../core/services/impl/section-services/vehicle-data/insurance-data-state.service';
import { VehicleStateEnum } from '../../../../core/consts/vehicle-state.enum';
import { VehicleStateStateService } from '../../../../core/services/impl/section-services/vehicle-data/vehicle-state-state.service';
import { PredefinedValuesService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import { Validator } from '../../../models/validator.enum';
import { VehicleModelConsts } from '../../../../core/consts/vehicle-model.consts';

export class VehicleDataSectionConfig {

  constructor(private vehicleDataStateService: VehicleDataStateService,
              private predefined: PredefinedValuesService,
              private insuranceDataStateService: InsuranceDataStateService,
              private vehicleStateStateService: VehicleStateStateService) { }

  createBeanConfig(fieldKey: string): BeanConfig {
    return {
      propertyName: 'questions',
      keyPropertyName: 'questionCode',
      valuePropertyName: 'questionAnswer',
      keyPropertyValue: VehicleQuestionCode[fieldKey]
    };
  }

  createVehicleDataConfig(): FormConfig {
    let formConfig = <FormConfig>{
      formKey: 'VEHICLE_DATA_SECTION',
      fieldsConfig: [
        {
          fieldKey: VehicleStateEnum.VEHICLE_CONDITION,
          caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.vehicleCondition',
          type: FieldType.Select,
          validators: [Validator.REQUIRED],
          displayInPreviewMode: true,
          options: {
            item: 'key',
            label: { label: 'label' },
            items: this.vehicleStateStateService.vehicleConditionDictionary.items
          },
          select: {
            dropdownPosition: 'bottom',
            multiple: false,
            searchable: true
          }
        },
        {
          fieldKey: VehicleStateEnum.DAMAGE_DESCRIPTION,
          caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.damageDescription',
          displayInPreviewMode: true,
          type: FieldType.TextArea,
          /**
           * validators for DAMAGE_DESCRIPTION field are set dynamically in component
           * and depend on VEHICLE_CONDITION field value
           */
          // validators: [
          //   Validator.REQUIRED,
          //   {
          //     name: Validator.MAX_LENGTH,
          //     maxLength: 1000c
          //   }
          // ]
        },
        {
          fieldKey: VehicleStateEnum.ABROAD_IMPORTED,
          caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.abroadImported',
          type: FieldType.Select,
          validators: [Validator.REQUIRED],
          displayInPreviewMode: true,
          options: {
            item: 'key',
            label: { label: 'label' },
            items: this.vehicleStateStateService.abroadImportedDictionary.items,
          },
          select: {
            dropdownPosition: 'bottom',
            multiple: false,
            searchable: true
          }
        },
        {
          fieldKey: VehicleModelConsts.FIRST_REGISTRATION_DATE,
          caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.firstRegistrationDate',
          type: FieldType.DateField,
          validators: [Validator.REQUIRED],
          displayInPreviewMode: true,
          materialDateFieldConfig: {
            startAt: () => this.vehicleDataStateService.getProductionDate(),
            reset: () => this.vehicleDataStateService.productionDateChange(),
            maxDate: this.vehicleDataStateService.getMaxFirstRegistrationDate(),
            startView: 'multi-year'
          },
        },
      ]
    };

    formConfig.fieldsConfig.forEach(fieldConfig => {
      this.predefined.addPredefinedValue(
        fieldConfig,
        this.predefined.values,
        formConfig.formKey,
        fieldConfig.fieldKey
      )
    });
    return formConfig;
  }
}
